import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './InputLabel.scss';
/**
 * Renders children in a `<label />`. This is a necessary element of all form elements.
 */
var InputLabel = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("label", __assign({ className: classnames(s['root'], className) }, rest), children));
};
InputLabel.displayName = 'InputLabel';
export default InputLabel;
//# sourceMappingURL=InputLabel.js.map